import { AppProviders } from './providers';
import { AppVersionBanner } from './AppVersionBanner';
import { AppRouter } from '@/routes/router';

export function App() {
  return (
    <AppProviders>
      <AppVersionBanner />
      <AppRouter />
    </AppProviders>
  );
}
